import { emit } from "../../analytics/analyticEmitter";

export const analyticsMiddleware = (store) => (next) => (action) => {
  if (CLIENT) {
    emit(action, store);
  }

  return next(action);
};
